import { UserSettingsContextFactory } from './UserSettingsContextFactory';

export const userSettingsContextDependencies = {
  userSettingsInteractor: UserSettingsContextFactory.userSettingsInteractor(),
};
